import React, { Component, Suspense } from 'react';
import renderHTML from 'react-render-html';
import Footer from './Footer';
// import {backgroundImage,get_json} from './common';
import { backgroundImage, api, basic_api, get_json,imagePath } from './common';
import { connect } from 'react-redux'
import Loader from './Loader'
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import ErrorBoundary from './Component/ErrorBoundary'
import { useImage } from 'react-image'
// import  {imagePath} from './common'
// import { SuspenseImg } from "./SuspenseImg.tsx";
function MyImageComponent(props) {
	//var images= props.Imagesrc.map(v => (v.image))
	const { src } = useImage({
		srcList:imagePath+ props.Imagesrc.image
	})
	console.log(src, "props")

	return (
		<div className="gallery-grid col-sm-6 col-md-4" key={props.index}>
			<div className="inner-main-gallery" onClick={() => props.onClick(props.index)}>
				<div className="img-div-gallery">

					<img className={"ff"} src={src} />


					<figcaption>
						<h3>{props.Imagesrc.title}</h3>
					</figcaption>
				</div>
			</div>
		</div>
	)
}

function BgComponent(props) {
	const { src } = useImage({
		srcList: require('./images/newsletter.jpg')
	})
	return (
		<div className="headerImage" style={{ backgroundImage: 'url(' + src + ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', height: 250, position: 'relative' }}>
			<div className="center_text">
				<h3 className="wthree_text_info">Gallery</h3>
			</div>
		</div>
	)
}

class Gallery extends Component {
	constructor(props) {
		super(props);
		this.state = { data: [], images_data: this.props.galleryRes, isloader: true, error: false, photoIndex: 0, isOpen: false };
	}
	async componentDidMount() {
		// if (this.props.alldata === null) {
		// 	await get_json(this)
		// 	this.props.setresponseJson(this.state.data)
		// } else {
		// 	await this.setState({ data: this.props.alldata })
		// }
		window.scrollTo(0, 0)
		var data = new FormData();
		data.append("action", "get_gallery_image")
		data.append("u_id", this.props.alldata.user_id)
		const requestOptions = {
			method: 'post',
			body: data
		};
		//if (this.props.galleryRes.length !== 0) { this.setState({ loader: false,images_data:this.props.galleryRes}) }
		fetch(api + basic_api, requestOptions)
			.then((response) => response.json())
			.then(async (responseJson) => {

				if (responseJson.success === "true") {
					await this.props.setgellaryRes(responseJson.data)
					await this.setState({ images_data: responseJson.data, isloader: false });

				} else {
					await this.setState({ error: true, isloader: false });
				}
			})
			.catch((error) => {
				this.setState({ isloader: false, error: true });
				console.log(error, "error")
			});
	}
	render() {
		const { photoIndex, isOpen } = this.state;
		const galleryRes = this.props.galleryRes
		const images = galleryRes.map(v => (v.image))
		return (

			<div className="main_contact">
			{/* {	<Suspense fallback={<div className="headerImage" style={{ height: 250, position: 'relative' }}>
					<div class="place_effect showed">
						<div class="img_div"></div>
					</div>
				</div>}>
					<BgComponent></BgComponent>
				</Suspense>} */}
				<div class="gallery-main-sec w-left">
					<div class="container">
					<div class="center_text">
                        <h3>Gallery</h3>
                    </div>
						{isOpen && (
							<Lightbox mainSrc={imagePath+images[photoIndex]}
								nextSrc={images[(photoIndex + 1) % images.length]}
								prevSrc={images[(photoIndex + images.length - 1) % images.length]}
								onCloseRequest={() => this.setState({ isOpen: false })}
								onMovePrevRequest={() =>
									this.setState({
										photoIndex: (photoIndex + images.length - 1) % images.length
									})
								}
								onMoveNextRequest={() =>
									this.setState({
										photoIndex: (photoIndex + 1) % images.length
									})
								}
							/>
						)}

						{(this.props.galleryRes.length === 0) ?
							["1", "2", "3", "4", "5", "6"].map((item, i) => (
								<div className="gallery-grid place-left col-sm-6 col-md-4">
									<div className="inner-main-gallery">
										<div className="img-div-gallery">
											<div className="place_effect showed">
												<div className="img_div" />
											</div>
										</div>
									</div>
								</div>))
							:
							<Suspense fallback={
								<div class="row">
									{["1", "2", "3", "4", "5", "6"].map((item, i) => (
										<div className="gallery-grid col-sm-6 col-md-4">
											<div className="inner-main-gallery">
												<div className="img-div-gallery">
													<div className="place_effect showed">
														<div className="img_div" />
													</div>
												</div>
											</div>
										</div>))}
								</div>
							}>
								<div class="row">

									{this.props.galleryRes.map((item, i) => (
										<MyImageComponent className={"ff"} Imagesrc={item} index={i} onClick={(i) => { this.setState({ photoIndex: i, isOpen: true }) }} />
									))}
								</div>
							</Suspense>

						}


					</div>
				</div>
				<Footer />
			</div>

		);
	}
}
const mapStateToProps = (state) => {
	console.log(state, "state")
	return {
		alldata: state.responseJson,
		galleryRes: state.galleryRes
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
		setgellaryRes: (data) => dispatch({ type: "GALLERY_RES", payload: data }),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Gallery);
// export default Gallery;